var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.324,
    height: 20.134,
    viewBox: "0 0 27.324 20.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18379",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18379",
    transform: "translate(-1280.999 -678.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Download",
    d: "M22.881,31.807l-1.233,1.243V27.706a.956.956,0,1,0-1.912,0v5.344L18.5,31.807a.96.96,0,0,0-1.357,1.357l2.868,2.868a.956.956,0,0,0,.315.2.9.9,0,0,0,.727,0,.956.956,0,0,0,.315-.2l2.868-2.868a.96.96,0,0,0-1.357-1.357Z",
    transform: "translate(1315.352 725.256) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Download-2",
    "data-name": "Download",
    d: "M24.457,7.766A9.572,9.572,0,0,0,6.188,10.351,5.47,5.47,0,0,0,7.473,21.14a1.367,1.367,0,1,0,0-2.735,2.735,2.735,0,0,1,0-5.47,1.367,1.367,0,0,0,1.367-1.367,6.837,6.837,0,0,1,13.306-2.2,1.367,1.367,0,0,0,1.067.916,4.1,4.1,0,0,1,.328,7.986,1.37,1.37,0,1,0,.684,2.653,6.837,6.837,0,0,0,.232-13.155Z",
    transform: "translate(1279.008 676.359)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloudIcon.ec462fd89b073c9536dc7c0eedc02b14.svg";
export { ForwardRef as ReactComponent };